module.exports = __webpack_public_path__ + "img/404-sorry-kid.ae9d3f1c.png";